import {
  AlertCircle,
  FileBarChart,
  FileCheck,
  Landmark,
  Store,
  TrendingDown,
} from "lucide-react";
import { FaRegRegistered } from "react-icons/fa6";
import { MdBalance } from "react-icons/md";
import LackOfReconciliationRoutes from "../../../pages/conciliation/lack-of-reconciliation/lack-of-reconciliation.route";
import StoresRoutes from "../../../pages/conciliation/stores/stores.route";
import RegisterEvidence from "../../../../src/pages/conciliation/evidence-register/evidence-register.route";
import NsuEvidence from "../../../pages/conciliation/nsu-register/nsu-register.route";
import { GroupsEnum } from "@/enum/groups";
import BalanceReportRoutes from "@/pages/conciliation/balance-report/balance-report.route";
import { RoleEnum } from "@/enum/role";
import ReportRoutes from "@/pages/conciliation/reports/reports-route";
import { createRoute } from "../createRoute";
import ManageLoss from "@/pages/conciliation/manage-loss";
import { PATH_IDS } from "../path-ids";
import { LuClipboardList } from "react-icons/lu";
import { DtefImport } from "@/pages/conciliation/dtef-import";
import DepositReconciliationRoutes from "@/pages/conciliation/deposit-reconciliation/deposit-reconciliation.route";
import DepositReportsRoutes from "@/pages/conciliation/deposit-reconciliation/admin/reports/reports.route";
import StoreExchangeListingRoutes from "@/pages/conciliation/store-exchange-listing/store-exchange-listing.routes";
import { Repeat2 } from "lucide-react";
import { CONCILIATION_CATEGORIES as CATEGORIES } from "./categories";
import { CONCILIATION_TAB_GROUPS, conciliationTabGroups } from "./tab-groups";

export const conciliationRoutes = [
  createRoute({
    id: "Lista de lojas",
    category: CATEGORIES.CONCILIACAO,
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/lojas/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <StoresRoutes />,
    Icon: Store,
  }),
  createRoute({
    id: "Conciliação de Depósitos",
    category: CATEGORIES.CONCILIACAO,
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/depositos/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <DepositReconciliationRoutes />,
    Icon: Landmark,
  }),
  conciliationTabGroups.createRoute(CONCILIATION_TAB_GROUPS.CONFIGURACOES),
  createRoute({
    id: "Consulta de Trocas",
    category: CATEGORIES.ADMINISTRATIVO,
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/consulta-de-trocas/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <StoreExchangeListingRoutes />,
    Icon: Repeat2,
  }),
  conciliationTabGroups.createRoute(CONCILIATION_TAB_GROUPS.DASHBOARD),
  createRoute({
    id: "Gerenciar perdas",
    category: CATEGORIES.ADMINISTRATIVO,
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/gerenciar-perdas/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <ManageLoss />,
    Icon: TrendingDown,
  }),
  conciliationTabGroups.createRoute(CONCILIATION_TAB_GROUPS.EMAILS),
  conciliationTabGroups.createRoute(CONCILIATION_TAB_GROUPS.DTEF),
  createRoute({
    id: "Falta de conciliação",
    category: CATEGORIES.RELATORIOS,
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/faltas-de-conciliacoes/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <LackOfReconciliationRoutes />,
    Icon: AlertCircle,
  }),
  conciliationTabGroups.createRoute(CONCILIATION_TAB_GROUPS.RELATORIOS_GERAIS),
  createRoute({
    id: "Registro de evidência",
    category: CATEGORIES.CONCILIACAO,
    requiredRole: [RoleEnum.USER],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/registro-de-evidencia/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <RegisterEvidence />,
    Icon: FaRegRegistered,
  }),
  createRoute({
    id: "Registro de NSU",
    category: CATEGORIES.CONCILIACAO,
    requiredRole: [RoleEnum.USER],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/registro-de-nsu/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <NsuEvidence />,
    Icon: FaRegRegistered,
  }),
  createRoute({
    id: "Relatorio de saldos",
    category: CATEGORIES.RELATORIOS,
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/relatorio-de-saldos/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <BalanceReportRoutes />,
    Icon: MdBalance,
  }),
  createRoute({
    id: "Painel de Monitoramento",
    category: CATEGORIES.RELATORIOS,
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/relatorios/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <ReportRoutes />,
    Icon: FileCheck,
  }),
  createRoute({
    id: "Relatórios de Depósitos",
    category: CATEGORIES.RELATORIOS,
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    path: "/depositos-relatorios/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <DepositReportsRoutes />,
    Icon: FileBarChart,
  }),
  createRoute({
    id: "Formas de Pagamento",
    category: CATEGORIES.DTEF,
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.CONCILIACAO],
    hiddenInSidebarOf: [GroupsEnum.CONCILIACAO, GroupsEnum.FINANCEIRO],
    path: "/importacao-dtef/*",
    pathId: PATH_IDS.CONCILIACAO,
    element: <DtefImport />,
    Icon: LuClipboardList,
  }),
  conciliationTabGroups.createRoute(CONCILIATION_TAB_GROUPS.RELATORIOS_VAR),
];
